/**
 * Created by xnr on 2020-03-31.
 */
import request from "../utils/fetch";
//新增按钮
export function btnadd(data) {
  return request({
    url: "/sys/btn/add",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}
//不分页,按钮列表
export function btnlist(data) {
  return request({
    url: "/user/button/pc/list",
    method: "get",
    requestBody: "null",
    loading: true,
    params: data,
  });
}
export function geturl(data) {
  return request({
    url: "/obs/test",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}
//修改按钮
export function btnupdate(data) {
  return request({
    url: "/sys/btn/update",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}
//不分页,菜单列表
export function menulist(data, requestOptions) {
  return request({
    url: "/user/sys/company/menu/info",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
    skipGlobalError: requestOptions && requestOptions.skipGlobalError,
  });
}

//不分页,菜单列表
export function sceneMenuList(data) {
  return request({
    url: "/user/scene/menu/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

//修改菜单状态
export function btnupdateStatus(data) {
  return request({
    url: "/sys/btn/updateStatus",
    method: "post",
    requestBody: "query",
    loading: true,
    data: data,
  });
}
//修改菜单状态
export function menuupdateStatus(data) {
  return request({
    url: "/user/menu/updateStatus",
    method: "post",
    requestBody: "query",
    loading: true,
    data: data,
  });
}
//不分页,接口列表
export function iflist(data) {
  return request({
    url: "/sys/if/list",
    method: "get",
    requestBody: "null",
    loading: true,
    params: data,
  });
}
//新增菜单
export function menuadd(data) {
  return request({
    url: "/sys/menu/add",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}
//修改菜单
export function menuupdate(data) {
  return request({
    url: "/sys/menu/update",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}
//删除菜单
export function menudelete(data) {
  return request({
    url: "/sys/menu/delete",
    method: "post",
    requestBody: "query",
    loading: true,
    data: data,
  });
}

//场景切换
export function sceneChange(data) {
  return request({
    url: "/user/sys/company/check/scene",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 拉公告列表
export function news(data) {
  return request({
    url: "/public/notice/enterprise/list",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}
export function news2(data) {
  return request({
    url: "/public/notice/enterprise/list2",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

//点击公告触发
export function gonews(data) {
  return request({
    url: "/public/notice/enterprise/info",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 消息数
export function msgNum(data) {
  return request({
    url: "/public/notice/enterprise/num",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}
// 员工菜单列表
export function userMenuList(data) {
  return request({
    url: "/user/h5/companyMenu/list",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

export function userMenuListNew(data) {
  return request({
    url: "/user/h5/companyMenu/new/list?serverId=" + data.serverId,
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 查看当前版本
export function versionsLook(data) {
  return request({
    url: "/public/version/publish/info",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

export function getCompanyName(data) {
  return request({
    url: "/company/company/get/companyName",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

